import React, { useState } from 'react';
import { Topic } from '../types/index.ts';
import TruncatedDescription from './TruncatedDescription.tsx';

interface ShareFeedbackModalProps {
  topic: Topic;
  onClose: () => void;
}

const ShareFeedbackModal: React.FC<ShareFeedbackModalProps> = ({ topic, onClose }) => {
  const [copied, setCopied] = useState(false);
  
  const feedbackUrl = `${window.location.origin}/?feedback=${topic.topicId || topic.id}&team=${topic.teamId}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(feedbackUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy URL:', err);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = feedbackUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h3>Share Feedback Link</h3>
        
        <div style={{ marginBottom: '20px' }}>
          <div style={{ marginBottom: '15px' }}>
            <strong>Topic:</strong> {topic.title}
          </div>
          <div style={{ marginBottom: '15px', color: '#666' }}>
            <TruncatedDescription description={topic.description} topicId={topic.topicId || topic.id} />
          </div>
          
          <div style={{ marginBottom: '10px' }}>
            <strong>Feedback URL:</strong>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input
              type="text"
              value={feedbackUrl}
              readOnly
              style={{
                flex: 1,
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px',
                backgroundColor: '#f9f9f9'
              }}
              onClick={(e) => (e.target as HTMLInputElement).select()}
            />
            <button
              onClick={handleCopy}
              style={{
                padding: '8px 12px',
                backgroundColor: copied ? '#28a745' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                minWidth: '60px'
              }}
            >
              {copied ? '✓' : 'Copy'}
            </button>
          </div>
          {copied && (
            <div style={{ color: '#28a745', fontSize: '12px', marginTop: '5px' }}>
              URL copied to clipboard!
            </div>
          )}
        </div>
        
        <div style={{ textAlign: 'right' }}>
          <button onClick={onClose} className="btn btn-secondary">Close</button>
        </div>
      </div>
    </div>
  );
};

export default ShareFeedbackModal;
